import { render, staticRenderFns } from "./FinancialAnalysis.vue?vue&type=template&id=135ff882&scoped=true"
import script from "./FinancialAnalysis.vue?vue&type=script&lang=js"
export * from "./FinancialAnalysis.vue?vue&type=script&lang=js"
import style0 from "./FinancialAnalysis.vue?vue&type=style&index=0&id=135ff882&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ff882",
  null
  
)

export default component.exports